import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import "./Notification.css";

const Notification = ({ show, message, onClose, type = "info" }) => {
  if (!show) return null;

  return (
    <div className={`notification ${type}`}>
      <span className="notification-message">{message}</span>
      <button className="notification-close-btn" onClick={onClose}>
        <AiOutlineClose size={18} />
      </button>
    </div>
  );
};

export default Notification;